import { z } from 'zod'

const req = { required_error: 'Requerido' }

// Schema de validación para crear campaña
export const campaniaCreateSchema = z.object({
  // Campos requeridos
  nombre_campania: z.string(req).min(1, 'Requerido').max(255),
  remitente: z.string(req).min(1, 'Requerido').max(255),
  target: z.string(req).min(1, 'Requerido').max(255),
  base_segmentada: z.string(req).min(1, 'Requerido').max(255),

  // CharFields derivados de FKs (se rellenan en onSubmit)
  marca: z.string().max(100).optional(),
  marca_secundaria: z.string().max(100).optional(),
  tipo: z.string().max(100).optional(),
  formato: z.string().max(100).optional(),
  estado_contenido: z.string().max(100).optional(),
  tipo_envio: z.string().max(100).optional(),
  estado_envio: z.string().max(100).optional(),
  estado_reporte: z.string().max(100).optional(),
  estado_aprobacion: z.string().max(100).optional(),

  // Campos opcionales
  nombre: z.string(req).min(1, 'Requerido').max(255),
  requiere_aprobacion: z.boolean().default(false),
  asunto: z.string().optional(),
  pre_encabezado: z.string().max(255).optional(),
  titulo_envio: z.string().max(500).optional(),
  archivo_url: z.string().url('URL inválida').optional().or(z.literal('')),
  contenido_html: z.string().optional(),
  fecha_publicacion: z.string(req).min(1, 'Requerido'),
  hora: z.string(req).min(1, 'Requerido'),
  reporte: z.string().optional(),
  notas: z.string().optional(),

  // ForeignKeys
  configuracion_fk_id: z.number().optional(),
  marca_principal_fk_id: z.number(req),
  marca_secundaria_fk_id: z.number(req),
  tipo_fk_id: z.number(req),
  formato_fk_id: z.number(req),
  estado_contenido_fk_id: z.number(req),
  estado_envio_fk_id: z.number(req),
  estado_reporte_fk_id: z.number().optional(),
  estado_aprobacion_fk_id: z.number().optional(),
  tipo_envio_fk_id: z.number(req),
  asesor_tonal_id: z.number().optional(),
})

export type CampaniaCreateInput = z.infer<typeof campaniaCreateSchema>
